/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Triggering-task cancellation when its condition is no longer applicable.
 */
export type EmployeeExecutionCancelTriggeringTaskResolution = {
    /**
     * Stable resolution discriminator.
     */
    kind: EmployeeExecutionCancelTriggeringTaskResolution.kind;
    /**
     * Non-empty explanation persisted with the task cancellation.
     */
    reason: string;
};
export namespace EmployeeExecutionCancelTriggeringTaskResolution {
    /**
     * Stable resolution discriminator.
     */
    export enum kind {
        CANCEL_AS_INAPPLICABLE = 'cancel-as-inapplicable',
    }
}

